__turbopack_context__.v({
  "marqueeContainer": "ABOYGG_marqueeContainer",
  "section": "ABOYGG_section",
  "slide": "ABOYGG_slide",
  "slideImage": "ABOYGG_slideImage",
  "track": "ABOYGG_track",
});
